import { LoadState } from "../../constants/enums";
import { defaultGoodsReceivedNoteItem } from "../grn";
import { defaultPurchaseOrderItem } from "../purchase-order/purchase-order.state";
import {
  IPurchaseInvoice,
  IPurchaseInvoiceItem,
  IPurchaseInvoiceState,
} from "./purchase-invoice.types";

export const defaultPurchaseInvoiceItem: IPurchaseInvoiceItem = {
  ...defaultGoodsReceivedNoteItem,
  grn_uuid: "",
  grn_no: "",
  category_head_uuid: null,
  category_head_name: null,
  expense_category_uuid: "",
  expense_category_name: "",
};

export const defaultPurchaseInvoice: IPurchaseInvoice = {
  purchase_invoice_uuid: null,
  grn_uuid: null,
  origin_from: null,
  origin_from_uuid: null,
  origin_from_document_no: null,
  origin_from_document_date: null,
  grn_no: null,
  purchase_invoice_type: "",
  dated: null,
  purchase_invoice_no: "",
  // project_code: null,
  project_uuid: null,
  project_name: null,
  challan_no: null,
  challan_date: null,
  po_data: [],
  eway_bill_no: null,
  lr_no: null,
  delivery_note: null,
  mode_of_payment: null,
  reference_no: null,
  other_references: null,
  buyers_order_no: null,
  dispatch_doc_no: null,
  delivery_note_date: null,
  dispatched_through: null,
  destination: null,
  bill_of_lading: null,
  motor_vehicle_no: null,
  products: [],
  total_amount_after_tax: null,
  total_amount: null,
  tcs: null,
  tcs_amount: null,
  tcs_sign: "ADD",
  discount: null,
  discount_amount: null,
  billing_company_uuid: null,
  billing_company_name: null,
  billing_company_branch_uuid: null,
  billing_company_branch_name: null,
  billing_company_address_line1: null,
  billing_company_address_line2: null,
  billing_company_address_city: null,
  billing_company_address_state: null,
  billing_company_address_country: null,
  billing_company_GSTIN: null,
  billing_company_code: null,
  billing_company_address_pincode: null,
  vendor_uuid: null,
  vendor_name: null,
  vendor_registration_type: null,
  vendor_address_line1: null,
  vendor_address_line2: null,
  vendor_address_city: null,
  vendor_address_state: null,
  vendor_address_country: null,
  vendor_GSTIN: null,
  vendor_code: null,
  vendor_address_pincode: null,
  dispatch_through: null,
  transport_id: null,
  transport_doc_no: null,
  transport_doc_date: null,
  bank_account_uuid: null,
  bank_account_name: null,
  attachments: [],
  rev_charge: null,
  consignee_phone_number: null,
  consignee_email: null,
  distance_from_eway: null,
  vendor_email: null,
  vendor_phone_number: null,
  vendor_contact_name: null,
  delivery_distance_for_eway: null,
  tax_amount: null,
  tax_type: null,
  status: "ACTIVE",
  main_category: "",
  sub_category: "",
};

export const defaultPurchaseInvoiceState: IPurchaseInvoiceState = {
  purchase_invoice_list: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  single_purchase_invoice: {
    data: defaultPurchaseInvoice,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
